const pad2 = (value: number): string => String(value).padStart(2, "0");

const parseChannelTimestamp = (value?: string): Date | null => {
  if (!value) return null;
  let normalized = value.includes("T") ? value : value.replace(" ", "T");
  // the contract timestamp is tz-naive UTC — without this, JS parses naive
  // strings as LOCAL and every optimistic box renders hours off.
  if (!/Z$|[+-]\d\d:?\d\d$/.test(normalized)) normalized = `${normalized}Z`;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
};

const sameDay = (a: Date, b: Date): boolean =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

const timeOfDay = (date: Date): string => `${pad2(date.getHours())}:${pad2(date.getMinutes())}`;

export const humanizeChannelTime = (value?: string, now = new Date()): string => {
  const date = parseChannelTimestamp(value);
  if (!date) return "No time";

  if (sameDay(date, now)) return `Today ${timeOfDay(date)}`;

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (sameDay(date, yesterday)) return `Yesterday ${timeOfDay(date)}`;

  const month = date.toLocaleString(undefined, { month: "short" });
  const day = date.getDate();
  const year = date.getFullYear();
  const yearPart = year === now.getFullYear() ? "" : `, ${year}`;
  return `${month} ${day}${yearPart} ${timeOfDay(date)}`;
};
